import { Col, Row } from "react-grid-system";

import styled from "styled-components";

export const StyledDecisionOverview = styled(Row)`
	p {
		font-size: 1.4rem;
		line-height: 1.6;
	}

	.desc *,
	.desc {
		font-size: 1.4rem;
		line-height: 1.6;
		overflow: hidden;
	}

	.limited {
		max-height: 268.8px;
	}

	button {
		margin-top: 2rem;
	}
`;

export const StyledMoreActionsTitle = styled(Col)`
	display: flex;
	align-items: center;
	margin-bottom: 1.2rem;
`;
